// extracted by mini-css-extract-plugin
module.exports = {"desc":"SectionHeader-module--desc--1jnTc"};